let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9u82Y")).then(() => parcelRequire('2OutL'));